import React from "react";
import ReactDOM from "react-dom";
import ChatApp from "./ChatApp.js";
import "@chatui/core/es/styles/index.less";
//import "./chatui-theme.css";
import './i18n';

const rootElement = document.getElementById("root");
ReactDOM.render(
  <React.StrictMode>
    <ChatApp />
  </React.StrictMode>,
  rootElement
);
